module.exports = "<h3>bp-checkboxtree</h3>\n<section style=\"margin-top: 30px;\">\n  <div>\n      <pre>\n        <code class=\"language-html\" ng-bind-html=\"vm.exampleHtml\"></code>\n      </pre>\n  </div>\n  <div class=\"alert alert-warning\">\n    <ul>\n      <li>\n        ng-model中的每条数据必须包含节点id才能正确回填\n      </li>\n      <li>\n        数据结构要求：\n        子节点必须包含parent字段 -父节点的id\n      </li>\n    </ul>\n  </div>\n</section>\n<h3>示例</h3>\n<section style=\"margin-top: 30px\">\n  <bp-checkboxtree list-promise=\"vm.listPromise\" ng-model=\"vm.form.catagory\"></bp-checkboxtree>\n  model数据：<pre>{{vm.form.catagory | json}}</pre>\n</section>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./examples/components/checkboxtree/template.html
 ** module id = 233
 ** module chunks = 0
 **/